import { Hex } from 'viem'
import { useMemo } from 'react'
import { makeReadContract, makeReadContracts } from '@/utils/wagmi/makeOperations'
import { abi } from '@/abi/Survey4'

export function makeReadSurvey4Contract(survey4Address: Hex) {
	return useMemo(() => makeReadContract(abi, () => survey4Address), [survey4Address])
}

/*
 * Fetches multiple methods from a Survey4 contract
 * @param survey4Addresses The addresses of the Survey4 contracts
 * @returns A hook to fetch multiple methods from the SurveyFactory contract
 */
export function makeReadSurvey4ContractMulti(survey4Addresses: Hex[]) {
	return useMemo(
		() => survey4Addresses.map(survey4Address => makeReadContracts(abi, () => survey4Address)),
		[survey4Addresses]
	)
}
